import { Component, OnInit } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { GeneralConstants } from '../../shared/general.constants';
import { DiscoveryService } from './discovery.service';

@Component({
    selector: 'discovery',
    templateUrl: 'discovery.component.html',
    styleUrls: []
})
export class DiscoveryComponent implements OnInit {
    constructor (private toasterService: ToasterService,
        private generalConstants: GeneralConstants,
        private discoveryService: DiscoveryService) {}

    private navIndex = 0;
    private wikiViews = undefined;
    private wikiPage = 1;
    private wikiDate;
    private torrents = {};
    private torrentParrotIds = [];
    private torrentsPage = 1;
    private loading = true;
    private loadMoreLoading = false;

    ngOnInit() {
        const dateObject = new Date();
        dateObject.setTime(dateObject.getTime() - 86400000 * 2);
        this.wikiDate = this.formatDate(dateObject);
        this.discoveryService.getWikiTitles(
            this.wikiDate, this.wikiPage
        ).then(res => {
            this.wikiViews = res.wikiviews;
            this.loading = false;
        }).catch(err => {
            console.error('Error is: ' + err);
            this.toasterService.pop('error', 'Failed to load wikipedia title views');
            this.loading = false;
        });
    }

    handleNavSelect(index) {
        this.navIndex = index;
        if (index === 1 && this.torrentParrotIds.length === 0) {
            this.handleTorrents();
        }
    }

    handleDateChange() {
        this.loading = true;
        this.wikiPage = 1;
        this.discoveryService.getWikiTitles(
            this.wikiDate, this.wikiPage
        ).then(res => {
            this.wikiViews = res.wikiviews;
            this.loading = false;
        }).catch(err => {
            console.error('Error is: ' + err);
            this.toasterService.pop('error', 'Failed to load wikipedia title views');
            this.loading = false;
        });
    }

    handleLoadMore() {
        this.wikiPage = this.wikiPage + 1;
        this.loadMoreLoading = true;
        this.discoveryService.getWikiTitles(
            this.wikiDate, this.wikiPage
        ).then(res => {
            this.wikiViews = this.wikiViews.concat(res.wikiviews);
            this.loadMoreLoading = false;
        }).catch(err => {
            console.error('Error is: ' + err);
            this.toasterService.pop('error', 'Failed to load additional wikipedia title views');
            this.loadMoreLoading = false;
        });
    }

    handleTorrents() {
        this.loading = true;
        this.discoveryService.getTorrentTitles()
        .then(res => {
            for (const torrent of res.torrentRecords) {
                if (this.torrents[torrent.currentParrotId]) {
                    this.torrents[torrent.currentParrotId].infohashCount += 1;
                    this.torrents[torrent.currentParrotId].viewsCount += torrent.cumulativeTotalRecords;
                    this.torrents[torrent.currentParrotId].infohashes.push(torrent);
                } else {
                    this.torrents[torrent.currentParrotId] = {
                        infohashes: [torrent],
                        infohashCount: 1,
                        viewsCount: torrent.cumulativeTotalRecords,
                        collapsed: false,
                        parrotId: torrent.currentParrotId
                    };
                }
            }
            this.torrentParrotIds = Object.keys(this.torrents);
            this.torrentParrotIds.sort((a, b) => {
                return this.torrents[b].viewsCount - this.torrents[a].viewsCount;
            });
            this.loading = false;
        })
        .catch(err => {
            console.error('Error is: ' + err);
            this.toasterService.pop('error', 'Failed to load torrent views');
            this.loading = false;
        });
    }

    handleTableRowClick(torrent) {
        torrent.collapsed = !torrent.collapsed;
    }

    openWikidata(wikidataId) {
        window.open('https://www.wikidata.org/wiki/' + wikidataId);
    }

    formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }
}


// WEBPACK FOOTER //
// ./src/app/catalogue/discovery/discovery.component.ts